import React from 'react';
import { useContactDealer } from 'site-modules/shared/components/inventory/contact-dealer/contact-dealer';
import { CarcodeButton } from 'client/site-modules/shared/components/carcode-button/carcode-button';
import { CarcodePriceSummary } from 'client/site-modules/shared/components/inventory/carcode-price-summary/carcode-price-summary';
import { StickyBar } from 'client/site-modules/shared/components/inventory/contact-dealer/sticky-bar/sticky-bar';
import { ContactDealerOverViewFactory } from './dealer-overview/contact-dealer-overview-factory';

export function ContactDealerLayout() {
  const {
    vinData,
    dealerInfo,
    isMobile,
    isVlaPage,
    isEmbeddedCarcode,
    isTopEmbeddedLeadFormEnabled,
    formattedPhone,
    ctasOptions,
    isProdEnv,
    isCapOneIneligible,
    isCapOneAvailable,
    handleCaramelMakeOffer,
    isCaramelOptInDealer,
    hideLeadForm,
    ted6504Recipe,
    privateListingData,
    dealer,
    isCarZingPrequalify,
    isVdpNonPartner,
  } = useContactDealer();

  const showCarcodeButton = isTopEmbeddedLeadFormEnabled ? !isEmbeddedCarcode : !isVdpNonPartner && !isMobile;
  const showStickyBar = isMobile && !isCarZingPrequalify;

  return (
    <>
      <ContactDealerOverViewFactory />

      {isEmbeddedCarcode && (
        <CarcodePriceSummary
          dealerInfo={vinData.dealerInfo}
          phoneNumber={formattedPhone}
          activEngageConfigLaunchSource="edmunds-vdp"
          isMobile={isMobile}
          useChatOnline
        />
      )}

      {showStickyBar && (
        <StickyBar
          vinData={vinData}
          ctasOptions={ctasOptions}
          isVlaPage={isVlaPage}
          dealerInfo={dealerInfo}
          isProdEnv={isProdEnv}
          isCapOneIneligible={isCapOneIneligible}
          isCapOneAvailable={isCapOneAvailable}
          handleCaramelMakeOffer={handleCaramelMakeOffer}
          isCaramelOptInDealer={isCaramelOptInDealer}
          hideLeadForm={hideLeadForm}
          ted6504Recipe={ted6504Recipe}
          privateListingData={privateListingData}
          dealer={dealer}
        />
      )}

      {showCarcodeButton && (
        <CarcodeButton
          dealerInfo={vinData.dealerInfo}
          customConfig={{ useGlobalCalloutStatus: true, skipButton: isMobile, zIndex: 1049 }}
          activEngageConfigLaunchSource="edmunds-vdp"
        />
      )}
    </>
  );
}
